module.exports = __webpack_public_path__ + "img/Media-protection-1.09080664.png";